import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-step-four-mautic',
  templateUrl: './step-four-mautic.component.html',
  styleUrls: ['./step-four-mautic.component.scss']
})
export class StepFourMauticComponent implements OnInit {

  @ViewChild('form', { static: false }) form: ElementRef<any>;
  formData: any;

  constructor(
    router: ActivatedRoute,
    @Inject('FORM_API_URL') public formApiUrl: string
  ) { 

    router.queryParams.subscribe(
      query => {
          this.formData = query;
          // console.log(query);
          setTimeout(() => this.form.nativeElement.submit(), 500);
      }
    )

  }

  ngOnInit(): void {
  }

}
